import { render, staticRenderFns } from "./ConfigurationHistoryItem.vue?vue&type=template&id=04177bb8&"
import script from "./ConfigurationHistoryItem.vue?vue&type=script&lang=js&"
export * from "./ConfigurationHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports